import {
  GearFillIcon,
  IconButton,
  PlusIcon,
  Popover,
  PopoverTrigger,
  PopoverMenu,
  PopoverMenuItem,
  PopoverMenuItemSeparator,
} from "@tandemdiabetes/sugarmate-react-components"
import {
  useCallback,
  useMemo,
} from "react"
import type { DeepReadonlyObject } from "rxdb"

import { useAccountInsulinModalContext } from "src/components/AccountInsulinModal"
import { usePolyglot } from "src/contexts"
import type { AccountInsulin } from "src/types"

const polyglotPrefix = "components.entry_modal.insulin.popover."

interface Props {
  currentAccountInsulin?: DeepReadonlyObject<AccountInsulin>;
}

export function AccountInsulinButton(props: Props) {
  const { currentAccountInsulin } = props
  const { openAccountInsulinModal } = useAccountInsulinModalContext()

  const polyglot = usePolyglot()

  const onClickCreate = useCallback(
    () => {
      openAccountInsulinModal()
    },
    [openAccountInsulinModal],
  )

  const onClickEdit = useMemo(
    () => !currentAccountInsulin
      ? undefined
      : () => {
        openAccountInsulinModal(currentAccountInsulin)
      },
    [
      currentAccountInsulin,
      openAccountInsulinModal,
    ],
  )

  if (!currentAccountInsulin) {
    return (
      <IconButton
        onClick={onClickCreate}
        id="add-insulin-btn"
      >
        <PlusIcon />
      </IconButton>
    )
  }

  return (
    <Popover placement="top-end">
      <PopoverTrigger asChild>
        <IconButton id="insulin-settings-btn">
          <GearFillIcon />
        </IconButton>
      </PopoverTrigger>
      <PopoverMenu
        aria-label={polyglot.t(`${polyglotPrefix}aria_label`)}
      >
        <PopoverMenuItem
          onClick={onClickEdit}
          disabled={!onClickEdit}
          autoDismiss
          id="edit-insulin-btn"
        >
          {polyglot.t(
            `${polyglotPrefix}edit_cta`,
            {
              name: currentAccountInsulin.insulin.name,
            },
          )}
        </PopoverMenuItem>
        <PopoverMenuItemSeparator />
        <PopoverMenuItem
          onClick={onClickCreate}
          autoDismiss
          id="add-insulin-btn"
        >
          {polyglot.t(`${polyglotPrefix}create_cta`)}
        </PopoverMenuItem>
      </PopoverMenu>
    </Popover>
  )
}
